import ManagedErrorToasts from '@/components/error/ManagedErrorToasts';
import AdminPageLayout from '@/components/layout/AdminPageLayout';
import ConsignmentAcknowledgementItemsTable from '@/components/shipments/tables/ConsignmentAcknowledgementItemsTable';
import { PharmacistShipmentProvider, usePharmacistShipment } from '@/context/shipments/PharmacistShipment';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';

import { Button, Chip } from '@montugroup/design-system';
import ArrowBack from '@mui/icons-material/ArrowBack';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Error404 from '../error/404';

export default function PharmacistShipmentAcknowledgement() {
  const params = useParams<{ id: string }>();

  if (!params.id) {
    return <Error404 />;
  }

  return (
    <PharmacistShipmentProvider id={params.id}>
      <ShipmentAcknowledgment />
    </PharmacistShipmentProvider>
  );
}

function ShipmentAcknowledgment() {
  const { key } = usePortalPartnerBrand();

  const { shipment, isError } = usePharmacistShipment();
  const navigate = useNavigate();
  const location = useLocation();

  if (isError) {
    return <Error404 />;
  }

  return (
    <AdminPageLayout
      title="Controlled Drug Receipt"
      testId="pharmacist-shipment-acknowledgment"
      subtitle={`Shipment Reference: ${shipment?.reference ?? ''}`}
      themeVariant={key}
      BackLink={
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            location.state?.from === '/shipments' ? navigate(-1) : navigate('/shipments');
          }}
          startIcon={<ArrowBack color="primary" />}
        >
          Back to Shipments
        </Button>
      }
      SubTitleAdornment={
        shipment?.acknowledgements.length ? (
          <Chip
            size={'small'}
            icon={<CheckCircleOutline color="success" />}
            label="Signed"
            sx={{
              backgroundColor: (theme) => theme.palette.success.main + '33', // add opacity
              color: (theme) => theme.palette.success.main,
              fontWeight: 500,
            }}
          />
        ) : null
      }
    >
      <ManagedErrorToasts />
      <ConsignmentAcknowledgementItemsTable />
    </AdminPageLayout>
  );
}
